import React from "react";
import DateRange from "../../../../UI/DateRange/DateRange";

// Style
import "./DateOption.scss";

const DateOption = ({ category, filterCategories, setFilterCategories, activeCategory }) => {
  const handleMatrixChange = (value) => {
    setFilterCategories((categories) => {
      categories[activeCategory].tempSelectedMatrix = value;
      categories[activeCategory].tempSelectedStartValue = "";
      categories[activeCategory].tempSelectedEndValue = "";
      categories[activeCategory].tempFilterCount = 0;
      return [...categories];
    });
  };

  const handleClearSelection = () => {
    setFilterCategories((categories) => {
      categories[activeCategory].tempSelectedMatrix = category.defaultSelectedMatrix;
      categories[activeCategory].tempSelectedStartValue = "";
      categories[activeCategory].tempSelectedEndValue = "";
      categories[activeCategory].tempFilterCount = 0;
      return [...categories];
    });
  };

  const setDateFilter = (startDate, endDate = "") => {
    setFilterCategories((categories) => {
      categories[activeCategory].tempSelectedStartValue = startDate;
      categories[activeCategory].tempSelectedEndValue = endDate;
      categories[activeCategory].tempFilterCount = 1;
      return [...categories];
    });
  };

  return (
    <div className="date-option-container">
      <div className="bottom">
        <div className="title-clear">
          <span className="title">{category.name}</span>
          <span className="clear" onClick={handleClearSelection}>
            Clear
          </span>
        </div>
        <div className="date-container form-group">
          <select
            className="date-matrix"
            onChange={(e) => {
              handleMatrixChange(e.target.value);
            }}
            value={category.tempSelectedMatrix ? category.tempSelectedMatrix : category.defaultSelectedMatrix}
          >
            {category.matrix.map((item, index) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
          <div className="date-picker">
            {category.tempSelectedMatrix === "Between" ? (
              <DateRange
                {...{
                  setDateFilter,
                  startDate: category.tempSelectedStartValue,
                  endDate: category.tempSelectedEndValue,
                }}
              />
            ) : (
              <input
                className="single-date-picker"
                type="date"
                value={category.tempSelectedStartValue ?? ""}
                onChange={(e) => setDateFilter(e.target.value)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateOption;
